<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="card">
                    <DataTable
                        ref="dt"
                        :value="datatable.data"
                        :loading="datatable.loading"
                        rowGroupMode="rowspan"
                        :groupRowsBy="['name','id']"
                        @rowReorder="onRowReorder"
                        style="font-size: 12px; overflow-x: auto"
                    >
                        <template #header>
                            <div style="text-align: left">
                                <a :href="route('api.busbar_docs.create')">
                                <Button icon="pi pi-external-link" label="Создать" />
                                </a>
                            </div>
                        </template>
                        <Column field="id" :rowReorder="true" :reorderableColumn="false" header="">
                            <template #body="slotProps">
                                <div class="table-actions">
                                    <a :href="route('api.busbar_docs.edit', {busbar_doc: slotProps.data.id})">
                                        <i :class="['p-datatable-reorderablerow-handle', 'pi pi-eye']" v-if="!slotProps.data.virtual"></i>
                                    </a>
                                        <delete-confirmation
                                            :route-path="route('api.busbar_docs.delete', {busbar_doc: slotProps.data.id})"
                                            :redirect-path="route('busbar.docs')"
                                            :title="'Удаление'"
                                            class="p-button-danger"
                                        />
                                </div>
                            </template>
                        </Column>
                        <Column field="id" header="#">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.uid ? slotProps.data.uid : slotProps.data.id
                                }}
                            </template>
                        </Column>
                        <Column field="title" header="Название файла">
                            <template #body="slotProps">
                                <a :href="slotProps.data.url" target="_blank">{{ slotProps.data.title }}</a>
                            </template>
                        </Column>
                    </DataTable>
                    <pagination v-model="filter.page" :records="total" :per-page="20" @paginate="loadLazyData()"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import AutoComplete from "primevue/autocomplete";
import CalculatorService from "../Services/CalculatorService";
import axios from "axios";
import DeleteConfirmation from '../mixins/components/delete.vue';
import Pagination from 'v-pagination-3';
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Row,
        ColumnGroup,
        Button,
        InputText,
        InputNumber,
        AutoComplete,
        DeleteConfirmation,
        Pagination,
    },
    data() {
        return {
            moment: moment,
            total: 0,
            filter: {
                page: 1,
                search: null,
                status: null,
                type: null,
                by: 'order',
                dir: 'desc',
            },
            filteredCompetitorArticles: null,
            selectedCompetitorArticle: [],
            tableDiscount: {},
            tableCount: {},
            defaultPercent: 0,
            defaultCount: 1,
            buyer: null,
            datatable: {
                loading: false,
                data: [],
                lazyParams: {}
            },
            virtualTableData: [],
            selectedbusbar_doc: null,
            deleteDialog: false,
            deletingbusbar_doc: false,
            selectedTableRow: null,
            emptyRowIndex: 0,
            focused: {},
            buyerReadonly: false,
            competitorIds: [],
            competitorArticleNameEdit: {},
        }
    },
    calculatorService: null,
    created() {
        this.calculatorService = new CalculatorService();
    },
    mounted() {
        this.loadLazyData();
    },
    methods: {
        onBuyerBlur() {
            if (this.datatable.lazyParams['buyer'] === this.buyer) {
                return;
            }

            this.loadLazyData();
        },

        deleteVirtualTableDataRow(competitorArticleName) {
            let virtualTableIndex = this.findVirtualTableRowIndex(competitorArticleName);

            this.virtualTableData.splice(virtualTableIndex, 1);
        },
        loadLazyData() {
            if (this.filter.search) {
                this.filter.page = 1;
            }
            
            this.datatable.lazyParams = {
                search: this.competitorIds,
            };
            this.datatable.loading = true;
            this.datatable.lazyParams['buyer'] = this.buyer;
            this.calculatorService.getData(this.route('api.busbar.docs', this.filter), this.datatable.lazyParams).then(data => {
                this.total = data.total;
                this.datatable.data = data.data.concat(this.virtualTableData);

                this.defineDefaultData();

                this.datatable.loading = false;

                window.scroll(0, 0);
            });
        },
        defineDefaultData() {
            this.datatable.data.forEach(function (data, index) {
                if (!data.id) {
                    return;
                }
                if (typeof this.tableDiscount[data.id] === "undefined") {
                    this.tableDiscount[data.id] = this.defaultPercent;
                }
                if (typeof this.tableCount[data.id] === "undefined") {
                    this.tableCount[data.id] = this.defaultCount;
                }
            }, this);
        },
        onRowReorder(event) {
            if (event.dragIndex === event.dropIndex) {
                return;
            }

            let moveId = this.datatable.data[event.dragIndex]['id'];
            let beforeId = this.datatable.data[event.dropIndex]['id'];

            let indexId = this.competitorIds.indexOf(moveId);
            let indexBeforeId = this.competitorIds.indexOf(beforeId);
            this.moveArrayItem(this.competitorIds, indexId, indexBeforeId);
            this.loadLazyData();
        },
        moveArrayItem(arr, fromIndex, toIndex) {
            let element = arr[fromIndex];
            arr.splice(fromIndex, 1);
            arr.splice(toIndex, 0, element);
        },
    }
}
</script>

<style scoped>
.p-button-danger {
    color: red;
}
.VuePagination .VuePagination__pagination-item {
    list-style: none!important;
}
.font-12 {
    font-size: 12px;
}
</style>